import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthRoutes, APIs, API_BASE_URL } from '../../constants/Constants';
import axiosInterceptor from '../../helpers/Interceptor';

const AgenticLogDownload = () => {
  const [message, setMessage] = useState('Preparing your download, please wait...');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const triggerDownload = async () => {
      const queryParams = new URLSearchParams(location.search);
      const startDate = queryParams.get('startDate');
      const endDate = queryParams.get('endDate');

      if (!startDate || !endDate) {
        setMessage('Error: startDate and endDate query parameters are required (YYYY-MM-DD).');
        setTimeout(() => navigate(AuthRoutes.STUDYLIST), 3000);
        return;
      }

      try {
        const response = await axiosInterceptor.get(
          API_BASE_URL + APIs.DOWNLOAD_AGENTIC_LOG,
          {
            params: { startDate, endDate },
            responseType: 'blob',
            withCredentials: true,
          }
        );

        if (response && response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = `agentic_event_log_${startDate}_to_${endDate}.csv`;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          
          setMessage('Download started! Redirecting you shortly...');
        } else {
          setMessage('An error occurred while downloading the log. Please check the date range (max 30 days).');
        }
      } catch (error) {
        console.error("Download failed", error);
        setMessage('Failed to initiate download. Please ensure you are authorized and dates are valid.');
      }

      setTimeout(() => {
        navigate(AuthRoutes.STUDYLIST);
      }, 3000);
    };

    triggerDownload();
  }, [navigate, location]);

  return (
    <div style={{ padding: '50px', textAlign: 'center', fontSize: '20px', fontFamily: 'Segoe UI' }}>
      <h1>{message}</h1>
    </div>
  );
};

export default AgenticLogDownload;
